module.exports = {
  "airTank": {
    "bindAccount": "绑定账号",
    "account": "账号",
    "peopleSearchKeywordHint": "登录账号/手机号/用户姓名",
    "phoneNumber": "手机号码",
    "pushToDevice": "推送到设备",
    "pushSure": "推送成功"
  },
}


// WEBPACK FOOTER //
// ./src/i18n/airTank/zh-CN.js